import React, { Component } from 'react'

class Facture extends Component {
    render(){
        return (<div>facture</div>);
    }
}

export default Facture


// WEBPACK FOOTER //
// ./src/components/content/Facture.js